/**
 * 兼容问题处理
 * 1.ios键盘收起页面错乱问题
 */

 function isIos(){
     var ua = navigator.userAgent.toLocaleLowerCase()
     if(ua.indexOf('iphone')>-1 || ua.indexOf('ipod')>-1 || ua.indexOf('ipad')>-1){ //iPhone|iPod|iPad
         return true
     }else{
         return false
     }
 }
 function keyboardUp(){
    var inputs = document.querySelectorAll("input");
    var textareas = document.querySelectorAll("textarea");
    var scrollTop = 0
    // console.log(inputs)
    for(var i = 0; i < inputs.length; i++){
      inputs[i].addEventListener('blur', function(){
        if (window.pageYOffset) {
          scrollTop= window.pageYOffset; 
        }else if (document.compatMode && document.compatMode != 'BackCompat'){
          scrollTop= document.documentElement.scrollTop; 
        }else if (document.body) {
          scrollTop= document.body.scrollTop; 
        } 
        console.log('top',scrollTop)
        window.scrollTo(0,0)
      })
    }
    for(var i = 0; i < textareas.length; i++){
      textareas[i].addEventListener('blur', function(){
        if (window.pageYOffset) {
          scrollTop= window.pageYOffset; 
        }else if (document.compatMode && document.compatMode != 'BackCompat'){
          scrollTop= document.documentElement.scrollTop; 
        }else if (document.body) {
          scrollTop= document.body.scrollTop; 
        } 
        console.log('top',scrollTop)
        window.scrollTo(0,0)
      })
    }  
 }
 function initCompate(){
     if(isIos()){
         console.log('ios compatibility')
         keyboardUp()
     }
 }
 export default initCompate